<template>
  <div class="container">
    <div class="title"><h1>Mission</h1></div>
    <div class="screen">
      <p class="aboutmetext">
        I am a <strong>human-centered technologist</strong> combining
        <strong>systems engineering</strong> with
        <strong>experience design</strong> to build tools that broaden and
        extend human capabilities.
      </p>
      <p class="aboutmetext">
        These tools <strong>perceive</strong> what is happening in the world,
        <strong>synthesize</strong> that data to extract meaning, and
        <strong>empower</strong> people to understand and take action.
      </p>

      <img class="testimg" src="../assets/pse-white.svg" />

      <p class="aboutmetext">
        Over the past 15 years, I have designed and built a wide variety of
        <strong>communication</strong>, <strong>collaboration</strong>, and
        <strong>control</strong> systems for clients ranging from government
        institutions and Fortune 500 companies to universities and nonprofit
        organizations.
      </p>
      <p class="aboutmetext">
        These systems have taken many forms, but they always put
        <strong>people first</strong>.
      </p>
    </div>
  </div>
</template>

<script>
// import Arrow from "./Arrow";

export default {
  name: "About",
  components: {
    // Arrow,
  },
};
</script>

<style scoped>
.screen {
  margin: auto;
  width: 95%;
  max-width: 100vh;
  min-height: 90%;
  display: flex;
  flex-direction: column;
}
.container {
  width: 100%;
  min-height: 100%;
  scroll-snap-align: start;
  background-color: var(--dark-bg);
  position: relative;
}
.title {
  height: 10%;
  padding-top: 0px;
  padding-bottom: 0px;
}

.testimg {
  max-height: 50vh;
  width: 100%;
  object-fit: contain;
  margin-top: 1vh;
  margin-bottom: 1vh;
}

.bottomspacer {
  height: 10vmin;
  max-height: 50px;
}
</style>
